import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    color: 'blue',
    border: '1px solid blue',
    borderRadius: '3px',
  },
  '&:hover': {
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'white',
    boxShadow: 'none',
  },
  button: {
    marginTop: theme.spacing(3),
      width: "100%"
  },
    nextButton: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(3),
        // display: 'flex',
        // margin: 'auto',
        fontSize: '1.5em',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        textTransform: "none"
    },
}))

interface NextButtonProps {
  handleClick: any
}

export default function NextButton(props: NextButtonProps) {
  const classes = useStyles()

  useEffect(() => {
    // setTimeout(function () {
    //   window.location.replace(props.sendTo)
    // }, props.timeout || 2000)
  })

  return (
    <React.Fragment>
      <div className={classes.button}>
        <Button fullWidth={true}
          variant="contained"
          color="primary"
          onClick={props.handleClick}
          className={classes.nextButton}
        >
          Next
        </Button>
      </div>
    </React.Fragment>
  )
}
